import { render, staticRenderFns } from "./InfoBasic.vue?vue&type=template&id=6ebe74f7"
import script from "./InfoBasic.vue?vue&type=script&lang=js"
export * from "./InfoBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports